module.exports = __webpack_public_path__ + "img/arrow-down-black.c06e278e.svg";